import { render, staticRenderFns } from "./GestionVacunaciones.vue?vue&type=template&id=4dbbc7ac&scoped=true"
import script from "./GestionVacunaciones.vue?vue&type=script&lang=js"
export * from "./GestionVacunaciones.vue?vue&type=script&lang=js"
import style0 from "./GestionVacunaciones.vue?vue&type=style&index=0&id=4dbbc7ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbbc7ac",
  null
  
)

export default component.exports